import {
	removeError,
	onSelectChange,
	onFieldInput,
	doFormValidation,
	scrollToFirstError,
	doPhoneFieldValidation, scrollElementTop
} from '../lib/forms';

let formAdd, formCheck;
let formAction = '/include/ajax/form-requests.php';

const init = () => {

	// rules accordion
	if (window.accordion) {
		document.querySelectorAll(`.requests__rules`)
			.forEach((accordion) => {
				window.accordion.init(accordion);
			});
	}

	formAdd = document.querySelector('.js-request-add');
	if (formAdd) {
		let fieldsRequired = [
			'FIO',
			'EMAIL',
			'TYPE',
			'TEXT',
		];

		fieldsRequired.forEach((fieldCode) => {
			let fieldElement = formAdd.querySelector('[name="'+fieldCode+'"]');
			if (!fieldElement) return;

			if (fieldElement.type === 'select-one') {
				fieldElement.addEventListener('change', onSelectChange);
			}
			else {
				fieldElement.addEventListener('input', onFieldInput);
			}
		});

		// submit
		let overlayElem = formAdd.querySelector('.form__overlay');
		let resultBlock = document.querySelector('.js-request-result');

		formAdd.addEventListener('submit', (e) => {
			e.preventDefault();

			let fieldsChecked = doFormValidation(formAdd, fieldsRequired, e);
			let phoneChecked = doPhoneFieldValidation(formAdd, 'PHONE', e);

			if (!fieldsChecked || !phoneChecked) {
				scrollToFirstError(formAdd);
				return;
			}

			let formData = new FormData(formAdd);
			formData.set('action', 'add');

			if (overlayElem) {
				overlayElem.style.display = 'block';
			}

			fetch(formAction, {
				method: 'POST',
				body: formData
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! Status: ${response.status}`);
					}
					return response.json();
				})
				.then((result) => {
					if (result.error) {
						throw new Error(result.message);
					}

					if (resultBlock) {
						resultBlock.querySelector('.js-result-num').innerHTML = result.id;

						formAdd.hidden = true;
						resultBlock.hidden = false;

						scrollElementTop(formAdd.parentElement);
					}
				})
				.catch((error) => {
					if (overlayElem) {
						overlayElem.style.display = 'none';
					}
					alert(error.message);
				});
		});
	}

	formCheck = document.querySelector('.js-request-check');
	if (formCheck) {

		let fieldsRequired = [
			'ID'
		];

		fieldsRequired.forEach((fieldCode) => {
			let fieldElement = formCheck.querySelector('[name="'+fieldCode+'"]');
			if (!fieldElement) return;

			fieldElement.addEventListener('input', onFieldInput);
		});

		// submit
		let overlayElem = formCheck.querySelector('.form__overlay');
		let resultBlock = document.querySelector('.js-request-check-result');

		formCheck.addEventListener('submit', (e) => {
			e.preventDefault();

			let fieldsChecked = doFormValidation(formCheck, fieldsRequired, e);

			if (!fieldsChecked) {
				return;
			}

			let formData = new FormData(formCheck);
			formData.set('action', 'check');

			if (overlayElem) {
				overlayElem.style.display = 'block';
			}

			fetch(formAction, {
				method: 'POST',
				body: formData
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! Status: ${response.status}`);
					}
					return response.json();
				})
				.then((result) => {
					if (result.error) {
						throw new Error(result.message);
					}

					if (overlayElem) {
						overlayElem.style.display = 'none';
					}

					if (resultBlock) {
						resultBlock.innerHTML = `
							<div class="requests--check__result-item">
								<div class="requests--check__result-item-title">
									Обращение от ${result.date}
									<span class="requests--check__result-item-name">Статус: "${result.status}"</span>
								</div>
								<div class="requests--check__result-item-application-plate">
									Номер обращения
									<span class="requests--check__result-item-application-number">${result.id}</span>
								</div>
							</div>`;

						resultBlock.hidden = false;
						scrollElementTop(formCheck.parentElement);
					}
				})
				.catch((error) => {
					if (overlayElem) {
						overlayElem.style.display = 'none';
					}

					if (resultBlock) {
						resultBlock.innerHTML = `<p class="message-error">${error.message}</p>`;
						resultBlock.hidden = false;
						scrollElementTop(formCheck.parentElement);
					}
				});
		});
	}
};

export default {
	init
};